module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/_library.js
// module id = 75
// module chunks = 0